import { create } from "zustand";
import type { TouchGhost } from "../features/calendar-view/touch-gesture-util.js";

interface InboxDragState {
  /** A touch-drag of an inbox item is in flight (mobile). */
  active: boolean;
  taskId: string | null;
  title: string;
  durationMinutes: number;
  /** Live finger position (viewport coords) for the floating ghost. */
  x: number;
  y: number;
  /** Calendar-shaped preview while the finger is over the week/day grid. */
  preview: TouchGhost | null;
  start: (taskId: string, title: string, durationMinutes: number, x: number, y: number) => void;
  move: (x: number, y: number) => void;
  setPreview: (preview: TouchGhost | null) => void;
  end: () => void;
}

/**
 * Mobile only: dragging an inbox item out onto the calendar to schedule it.
 * HTML5 drag-and-drop is mouse-only, so on touch we long-press an inbox row to
 * pick it up, follow the finger with a floating ghost (the inbox drawer goes
 * transparent), and on release the calendar's registered drop resolver maps the
 * drop point to a day + time. See `calendar-view/touch-drop.ts`.
 */
export const useInboxDragStore = create<InboxDragState>((set) => ({
  active: false,
  taskId: null,
  title: "",
  durationMinutes: 60,
  x: 0,
  y: 0,
  preview: null,
  start: (taskId, title, durationMinutes, x, y) => set({ active: true, taskId, title, durationMinutes, x, y, preview: null }),
  move: (x, y) => set({ x, y }),
  setPreview: (preview) => set({ preview }),
  end: () => set({ active: false, taskId: null, title: "", durationMinutes: 60, preview: null }),
}));
